import { createSelector } from '@ngrx/store';
import { IShareholderSummaryInfo } from '@appShared/interfaces/[Model-based]/shareholder-summary-info.interface';
import { getShareholderFeatureState } from '@appState/reducers/shareholder.reducer';

// export const getItemState = createSelector(
//  fromFeature.getProfileFeatureState,
//  (state: fromFeature.ProductsAdminState) => state.items
// );

// export const getUserProfile = createSelector(
//  getProfileFeatureState,
//  state => state.userProfile
// );


export const getShareholders = createSelector(
  getShareholderFeatureState,
  state => state.shareholders
);

export const getShareholderSearchFilter = createSelector(
  getShareholderFeatureState,
  state => state.searchFilter
);

export const getFilteredShareholders$ = createSelector(
  getShareholders,
  getShareholderSearchFilter,
  (shareholders: IShareholderSummaryInfo[], searchFilter: string) => {
    const filterBy = searchFilter?.toLocaleLowerCase();

    if (filterBy) {
      return shareholders.filter((shareholder: IShareholderSummaryInfo) => {
        return (
          shareholder.displayName.toLocaleLowerCase().indexOf(filterBy) !==
          -1 ||
          shareholder.pin.toString()
            .toLocaleLowerCase()
            .indexOf(filterBy) !== -1 ||
          shareholder.totalAdjustedShareOffer
            .toString()
            .indexOf(filterBy) !== -1 ||
          shareholder.totalDividendsAmountPaid
            .toString()
            .indexOf(filterBy) !== -1 ||
          shareholder.totalPurchasedShares
            .toString()
            .toLocaleLowerCase()
            .indexOf(filterBy) !== -1 ||
          shareholder.totalEvergreenShares
            .toString()
            .indexOf(filterBy) !== -1

        );
      });
    }

    return shareholders;
  }
);

